import React from 'react';
export function EnergySection() {
  return <div className="max-w-7xl mx-auto px-4 py-12" data-id="element-49">
      <h2 className="text-3xl font-bold text-gray-900 mb-8" data-id="element-50">Água e Energia</h2>
      <div className="grid md:grid-cols-2 gap-6 mb-6" data-id="element-51">
        <div className="relative h-64 rounded-lg overflow-hidden" data-id="element-52">
          <img src="https://images.unsplash.com/photo-1509391366360-2e959784a276?w=600" alt="Energias Renováveis" className="w-full h-full object-cover" data-id="element-53" />
          <div className="absolute inset-0 bg-gradient-to-t from-black to-transparent flex flex-col justify-end p-6 text-white" data-id="element-54">
            <h3 className="text-xl font-bold mb-2" data-id="element-55">
              Energias Renováveis do Mar
            </h3>
            <button className="bg-white text-blue-900 px-4 py-1 rounded text-sm font-semibold w-fit" data-id="element-56">
              Explorar
            </button>
          </div>
        </div>
        <div className="relative h-64 rounded-lg overflow-hidden" data-id="element-57">
          <img src="https://images.unsplash.com/photo-1473341304170-971dccb5ac1e?w=600" alt="Recursos Hídricos" className="w-full h-full object-cover" data-id="element-58" />
          <div className="absolute inset-0 bg-gradient-to-t from-black to-transparent flex flex-col justify-end p-6 text-white" data-id="element-59">
            <h3 className="text-xl font-bold mb-2" data-id="element-60">
              Gestão de Recursos Hídricos
            </h3>
            <button className="bg-white text-blue-900 px-4 py-1 rounded text-sm font-semibold w-fit" data-id="element-61">
              Explorar
            </button>
          </div>
        </div>
      </div>
      <div className="relative h-80 rounded-lg overflow-hidden" data-id="element-62">
        <img src="https://images.unsplash.com/photo-1532601224476-15c79f2f7a51?w=1200" alt="Energia Eólica Offshore" className="w-full h-full object-cover" data-id="element-63" />
        <div className="absolute inset-0 bg-gradient-to-t from-black to-transparent flex flex-col justify-end p-8 text-white" data-id="element-64">
          <h3 className="text-2xl font-bold mb-2" data-id="element-65">Energia Eólica Offshore</h3>
          <button className="bg-white text-blue-900 px-4 py-2 rounded text-sm font-semibold w-fit" data-id="element-66">
            Explorar
          </button>
        </div>
      </div>
    </div>;
}